import React from 'react';
import { Grid, Header, Button, Icon } from 'semantic-ui-react';

const PaymentSuccessPage = (props) => {
	return (
		<Grid centered>
			<Grid.Column>
				<Header
					as="h1"
					textAlign="center"
				>
					<Icon.Group size="large">
						<Icon
							name="circle outline"
							color="green"
						/>
						<Icon
							name="check"
							color="green"
							size="tiny"
						/>
					</Icon.Group>
					Payment Successful
				</Header>
				<center>
					<p>Processing your Payment was successful.</p>
					<Button
						primary
						type="sumbit"
						onClick={
							() => props.history.push('/tickets')
						}
					>
						BACK TO HOME
					</Button>
				</center>
			</Grid.Column>
		</Grid>
	);
};

export default PaymentSuccessPage;
